import { MonoTypeOperatorFunction, Observable, of, throwError } from 'rxjs';
import { delay, retry } from 'rxjs/operators';

export function httpRetry<T>(
    retryCount: number = 5,
    retryWaitMilliSeconds: number = 500
): MonoTypeOperatorFunction<T> {
    return (source: Observable<T>) => {
        return source.pipe(
            retry({
                delay: (error, count) => {
                    if (
                        count <= retryCount &&
                        [504, 503, 502, 429].includes(error.status)
                    ) {
                        console.error(`Http Error: retry ${count}`, error);
                        return of(error).pipe(
                            delay(count * retryWaitMilliSeconds)
                        );
                    }
                    return throwError(() => error);
                },
            })
        );
    };
}
